import { Container } from "components/Components";
import React from "react";

export const Home = () => 
    <Container>
        <h2>Home Page</h2>
        <p>Welcome to Qutex!</p>

        <p>This site is still under construction but has been made available as a preview.</p>
        
        <p>Please be patient while we bring it online.</p>
    </Container>;